<template>
    <div>
      <a-modal
        :centered = "true"
        :visible="visible"
        :closable = "true"
        :keyboard="false"
        :maskClosable="false"
        width="1000px"
        :mask="true"
        :title="$t('statistics.newMeeting.types.[10].name')"
        :destroyOnClose="true"
        @cancel="visible = false"
       >
        <div>
          <div class="content" v-if="tableData.length > 0">
            <div class="title_tip">
              <div class="tip_icon">
                <pt-icon type="icon-GroupCopy2" style="font-size: 16px"></pt-icon>
              </div>
              <div class="">
                <div class="sub_title">{{$t('key14chaoqiyingshoutishiLeader')}}</div>
              </div>
            </div>
            <div class="table_div">
                <pt-simple-table
                  class="dealBeOver_table"
                  :loading="loading"
                  :dataSource="tableData"
                >
                  <template slot="columns">
                    <el-table-column
                      prop="projectName"
                      align="left"
                      min-width="100"
                      show-overflow-tooltip
                      :label="$t('keyxiangmumingcheng')"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="payerName"
                      align="left"
                      min-width="100"
                      show-overflow-tooltip
                      :label="$t('key14fukuanfang')"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="totalComminssion"
                      align="left"
                      min-width="100"
                      show-overflow-tooltip
                      :label="$t('key14yongjinjine')"
                    >
                      <template slot-scope="scope">
                        ¥{{scope.row.totalComminssion}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="changeOutTime"
                      align="left"
                      min-width="115"
                      show-overflow-tooltip
                      :label="$t('chargeOutriqi')">

                    </el-table-column>
                    <el-table-column
                      prop="expectPayeeTime"
                      align="left"
                      min-width="100"
                      :label="$t('keyyujishoukuanriqi')">
                      <template slot-scope="scope">
                        <span>{{scope.row.expectPayeeTime}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="changePayTimeCount"
                      align="left"
                      min-width="100"
                      :label="$t('keyyixiugaicishu')">
                      <template slot-scope="scope">
                        <span>{{scope.row.changePayTimeCount}}{{ $t('common.times') }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="left"
                      min-width="200"
                      :label="$t('financial.receivableDetail.projectPerson')"
                    >
                      <template slot-scope="scope">
                        <div style="width: 185px;word-break: keep-all;">
                          {{
                            (scope.row.dealConfrimPartakeDOList || [])
                              .map(item => item.name)
                              .join('、')
                          }}
                        </div>
                      </template>
                    </el-table-column>
                  </template>
                </pt-simple-table>
            </div>
          </div>
          <div class="content" v-if="expiringSoonTableData.length > 0">
            <div class="title_tip" style="margin-top: 10px;">
              <div class="tip_icon">
                <pt-icon type="icon-GroupCopy2" style="font-size: 16px"></pt-icon>
              </div>
              <div class="">
                <div class="sub_title">{{$t('key14chaoqiyingshoutishiUpdateLeader')}}</div>
              </div>
            </div>
            <div class="table_div">
                <pt-simple-table
                  class="dealBeOver_table"
                  :loading="saveLoading"
                  :data-source="expiringSoonTableData"
                >
                  <template slot="columns">
                    <el-table-column
                      prop="projectName"
                      align="left"
                      min-width="100"
                      show-overflow-tooltip
                      :label="$t('keyxiangmumingcheng')"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="payerName"
                      align="left"
                      min-width="100"
                      show-overflow-tooltip
                      :label="$t('key14fukuanfang')"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="totalComminssion"
                      align="left"
                      min-width="100"
                      show-overflow-tooltip
                      :label="$t('key14yongjinjine')"
                    >
                      <template slot-scope="scope">
                        ¥{{scope.row.totalComminssion}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="changeOutTime"
                      align="left"
                      min-width="115"
                      show-overflow-tooltip
                      :label="$t('chargeOutriqi')">

                    </el-table-column>
                    <el-table-column
                      prop="expectPayeeTime"
                      align="left"
                      min-width="100"
                      :label="$t('keyyujishoukuanriqi')">
                      <template slot-scope="scope">
                        <span>{{scope.row.expectPayeeTime}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="changePayTimeCount"
                      align="left"
                      min-width="100"
                      :label="$t('keyyixiugaicishu')">
                      <template slot-scope="scope">
                        <span>{{scope.row.changePayTimeCount}}{{ $t('common.times') }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="left"
                      min-width="200"
                      :label="$t('financial.receivableDetail.projectPerson')"
                    >
                      <template slot-scope="scope">
                        <div style="width: 185px;word-break: keep-all;">
                          {{
                            (scope.row.dealConfrimPartakeDOList || [])
                              .map(item => item.name)
                              .join('、')
                          }}
                        </div>
                      </template>
                    </el-table-column>
                  </template>
                </pt-simple-table>

            </div>
          </div>
        </div>

        <div slot="footer">
          <a-button :loading="loading" key="submit"  type="primary"  style="margin-right: 10px" @click="visible = false">{{ $t('common.understood') }}</a-button>
        </div>
      </a-modal>

    </div>
</template>

<script>
  import DealConfrimApi from '@/api/mine/dealConfirm'
  export default {
    name: 'LeaderDealConfrimBeOverDue',
    data() {
      return {
        loading:false,
        visible:false,
        saveLoading:false,
        canedit:false,
        tableData:[],
        expiringSoonTableData:[],
        currentCreateTime:'',
      }
    },
    mounted() {
      this.selectDeal();
    },
    methods: {
      selectDeal(){
        this.loading = true
        DealConfrimApi.selectBeOverdueAllLeader().then(res=>{
          if(res.code == 1){
            if(res.data){
              if(res.data != null && res.data.length > 0){
                this.tableData = res.data;
              }
            }
          }
          this.selectBeOverdueAllExpiringSoon()
        }).finally(() => {
          this.loading = false
        })
      },
      selectBeOverdueAllExpiringSoon(){
        this.saveLoading = true
        DealConfrimApi.selectBeOverdueAllExpiringSoonLeader().then(res=>{
          if(res.code == 1){
            if(res.data){
              if(res.data != null && res.data.length > 0){
                this.expiringSoonTableData = res.data;
              }
            }
          }
          if(this.tableData.length > 0 || this.expiringSoonTableData > 0){
            this.visible = true;
          }else{
            this.visible = false;
          }
        }).finally(() => {
          this.saveLoading = false
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .table_div /deep/ .el-table td, .el-table th.is-leaf{
    border-bottom: 0px solid #EBEEF5 !important;
  }
  .table_div /deep/ .el-table--fit{
    padding: 20px;
  }
  .table_div /deep/  .el-table, .el-table__expanded-cell {
    background-color: rgba(248,249,251,0.62);
  }

  .table_div /deep/ .el-table tr {
    background-color:  rgba(248,249,251,0.62)!important;
  }
  .table_div /deep/  .el-table--enable-row-transition .el-table__body td, .el-table .cell{
    background-color:  rgba(248,249,251,0.62);
  }
  .content{
    padding: 0px 10px;
    .title_tip{
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 10px;
      .tip_icon{

      }
      .tip_content{
        margin-left: 10px;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
      }
      .sub_title{
        margin-left: 10px;
        font-size: 14px;
        color: #999999;
        letter-spacing: 0;
      }
    }
    .table_div{
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
      border-radius: 0px 0px 4px 4px;
      /deep/ .el-table{
        padding: 0px 20px !important;
      }
      /deep/ .el-table:before{
        display: none;
      }
    }
    .trackTypeText{
      width: 60px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

</style>